import { useTheme } from "@bps/fluent-ui";

interface DeploymentDetailTimelineAnnotationProps {
  styles: React.CSSProperties;
  text: string;
}

export const DeploymentDetailTimelineAnnotation: React.FC<DeploymentDetailTimelineAnnotationProps> = ({
  styles,
  text
}) => {
  const theme = useTheme();

  return (
    <div
      style={{
        ...styles,
        position: "absolute",
        pointerEvents: "none",
        zIndex: 1000
      }}
    >
      {/* Vertical red line */}
      <div
        style={{
          height: "100%",
          width: 2,
          backgroundColor: theme.palette.red,
          position: "absolute",
          top: 0,
          left: 0
        }}
      />

      <div
        style={{
          position: "absolute",
          top: "10%",
          left: 6,
          transform: "translateY(-50%)",
          backgroundColor: theme.palette.white,
          color: "red",
          padding: "2px 6px",
          borderRadius: 4,
          fontWeight: "bold",
          fontSize: "12px",
          boxShadow: "0 0 4px rgba(0,0,0,0.3)",
          whiteSpace: "nowrap"
        }}
      >
        {text}
      </div>
    </div>
  );
};
